export const setTokens = (response) => {
  const { access_token, refresh_token } = response.data;
  localStorage.setItem('@bc-t', access_token);
  localStorage.setItem('@bc-rt', refresh_token);
};

export const removeTokens = () => {
  localStorage.removeItem('@bc-t');
  localStorage.removeItem('@bc-rt');
};
